(function () {
  if (window.__csCartBound) return; window.__csCartBound = true;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  /* PREVIEW SAFETY (no-op once published): if a cart response ever comes back rendered by a different
     theme (happens when the preview session isn't attached to background requests — the stock Shrine
     drawer gets swapped in), reload the page with the preview pinned instead of showing the wrong cart. */
  var T = window.Shopify && window.Shopify.theme;
  function wrongTheme(state) {
    if (!T || T.role !== 'unpublished' || !state || !state.sections) return false;
    var html = state.sections['cart-drawer'] || '';
    return html.indexOf('cs-head') === -1;
  }

  function drawer() { return document.querySelector('cart-drawer'); }
  function busy(on) { var b = document.getElementById('cs-body'); if (b) b.classList.toggle('cs-busy', on); }

  function rerender(state) {
    var d = drawer(); if (!d) return;
    if (state && state.sections) {
      d.renderContents(state);
      if (state.item_count === 0) { d.classList.add('is-empty'); } else { d.classList.remove('is-empty'); }
      setTimeout(sweepBonus, 50);
    }
  }

  /* Bonus items (order insurance, free gift) are only free while the 2-pair deal holds.
     If one is ever showing a price, remove it so the customer is never charged for a "free" item. */
  function sweepBonus() {
    var d = drawer(); if (!d) return;
    var paid = d.querySelector('.cs-line[data-bonus-paid]');
    if (paid) changeLine(paid.dataset.key, 0);
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS, sections_url: window.location.pathname }, body)) })
      .then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    busy(true);
    post(window.routes.cart_change_url + '.js', { id: key, quantity: qty })
      .then(rerender).catch(console.error).finally(function () { busy(false); });
  }

  function addVariant(id) {
    busy(true);
    post(window.routes.cart_add_url + '.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(rerender).catch(console.error).finally(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var d = drawer(); if (!d || !d.contains(e.target)) return;

    var co = e.target.closest('.cs-checkout');
    if (co) { e.preventDefault(); co.disabled = true; co.textContent = 'ONE MOMENT…'; window.location.href = '/checkout'; return; }

    var q = e.target.closest('[data-qty]');
    if (q) { var line = q.closest('.cs-line'); if (line) changeLine(line.dataset.key, Number(q.dataset.qty)); return; }

    var add = e.target.closest('.cs-add');
    if (add) { add.disabled = true; addVariant(add.dataset.variant); return; }

    var ch = e.target.closest('.cs-change');
    if (ch) { var fit = ch.closest('.cs-fit'); fit.querySelector('.cs-fit-label').hidden = true; fit.querySelector('.cs-picker').hidden = false; return; }
  });

  /* Variant pickers on add-on cards.
     .cs-variant = the real variant list (source of truth for the ADD button).
     .cs-opt[data-opt=1|2] = two visible dropdowns (colour + size) that resolve to one .cs-variant option. */
  document.addEventListener('change', function (e) {
    var card = e.target.closest('.cs-card'); if (!card) return;
    var sel = card.querySelector('.cs-variant'); var add = card.querySelector('.cs-add');
    if (e.target.classList.contains('cs-opt')) {
      var o1 = card.querySelector('.cs-opt[data-opt="1"]').value, o2 = card.querySelector('.cs-opt[data-opt="2"]').value;
      var match = Array.prototype.find.call(sel.options, function (o) { return o.dataset.o1 === o1 && o.dataset.o2 === o2 && !o.disabled; });
      if (match) { sel.value = match.value; add.disabled = false; add.textContent = 'ADD'; }
      else { add.disabled = true; add.textContent = 'SOLD OUT'; return; }
    } else if (!e.target.classList.contains('cs-variant')) { return; }
    add.dataset.variant = sel.value;
  });

  /* Shrine's product-form.js calls cart.renderContents(response) after add-to-cart; keep is-empty in sync */
  document.addEventListener('DOMContentLoaded', function () {
    var d = drawer(); if (!d) return;
    sweepBonus();
    /* Guard Shrine's own add-to-cart path (product-form.js calls renderContents directly) */
    if (T && T.role === 'unpublished' && typeof d.renderContents === 'function') {
      var _rc = d.renderContents.bind(d);
      d.renderContents = function (state) {
        if (wrongTheme(state)) {
          var u = new URL(window.location.href); u.searchParams.set('preview_theme_id', T.id);
          window.location.replace(u.toString()); return;
        }
        return _rc(state);
      };
    }
    var mo = new MutationObserver(function () {
      var hasLines = !!d.querySelector('.cs-line');
      d.classList.toggle('is-empty', !hasLines);
    });
    mo.observe(d, { childList: true, subtree: true });
  });
})();
